import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class ArtifactsTableCellCreatedByComponent extends Component {
  @service store;
  @tracked isLoading = true;
  @tracked person = null;

  @action
  async loadPerson() {
    if (!this.args?.createdBy?.id) {
      this.isLoading = false;
      return;
    }

    try {
      // First try to peek the record from the store
      let person = this.store.peekRecord('person', this.args.createdBy.id);

      if (person) {
        this.person = person;
        this.isLoading = false;
      } else {
        // If not in store, try to find it
        person = await this.store.findRecord('person', this.args.createdBy.id);
        this.person = person;
        this.isLoading = false;
      }
    } catch (error) {
      console.error('Error loading person:', error);
      this.isLoading = false;
    }
  }
}
